import { IconCircleFilled } from '@calendly/ui/components/glyphs/IconCircleFilled'
import { LockIcon } from '@calendly/ui/components/icons'
import { useTooltip } from '@calendly/ui/components/tooltip'
import { BodyText } from '@calendly/ui/components/typography'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import { getEventTypeColorToken } from '@calendly/ui/utils/event-type-colors'

import { AdminManagedBadge } from 'components/core/admin_managed_badge'

import {
  EventTypeListDetailContainer,
  EventTypeListDetailRow,
  EventTypeListItem,
  HiddenText,
  LockContainer,
  StyledCheckboxField
} from './styles'
import { infoForLocation } from '../../utils'


export const EventTypeItem = ({ eventType, checked, onChange, currentEventType }) => {
  const { id, name, color, locationTypes, editLockedHint, kindDescription, metChild,
    durationDescription, adminManaged, groupManaged, canEdit, availabilityLocked } = eventType
  const [Tooltip, tooltipHostProps] = useTooltip(editLockedHint)

  const showKind = kindDescription !== 'One-on-One'
  const isMetChild = metChild || groupManaged
  // In V3 with only default schedule ET always MET child availability is locked
  // When we bring back multiple schedule user should be able to change to another schedule
  // but not uncheck current one so it won't change to custom
  const isCurrentEventType = (currentEventType && String(eventType.id) === String(currentEventType.id))
  const isDisabled = !canEdit || adminManaged || availabilityLocked || isCurrentEventType || !eventType.id

  return (
    <EventTypeListItem key={id} disabled={isDisabled} {...tooltipHostProps}>
      <StyledCheckboxField
        onChange={(enabled) => onChange(id, enabled)}
        checked={checked}
        disabled={isDisabled}
        label={<HiddenText>{name}</HiddenText>}
      />
      <UiIcon
        icon={IconCircleFilled}
        color={getEventTypeColorToken(color)}
        size="small"
      />
      <EventTypeListDetailContainer>
        <BodyText weight="bold" size="medium">{name}</BodyText>
        <EventTypeListDetailRow>
          <BodyText size="medium">
            {durationDescription}
          </BodyText>
          {locationTypes.length > 0 && (
            <>
              •
              <BodyText size="medium">
                {infoForLocation(locationTypes)}
              </BodyText>
            </>
          )}
          {showKind && (
            <>
              •
              <BodyText size="medium">
                {kindDescription}
              </BodyText>
            </>
          )}
        </EventTypeListDetailRow>
        {isMetChild && (<AdminManagedBadge groupManaged={groupManaged} pillStyle />)}
      </EventTypeListDetailContainer>
      {isDisabled && (
        <>
          <LockContainer><LockIcon inline size="large" /></LockContainer>
          <Tooltip />
        </>
      )}
    </EventTypeListItem>
  )
}
